import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/avatars/150-26.jpg"
  })
], -1)
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2" }, "Operator", -1)
const _hoisted_8 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = { class: "menu-item px-5" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" My Profile ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_13 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_14 = { class: "menu-title position-relative" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Language ")
const _hoisted_16 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/indonesia.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Indonesia ")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "menu-item px-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/united-states.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" English ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "menu-item px-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/spain.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Spanish ")
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "menu-item px-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/germany.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" German ")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "menu-item px-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/japan.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Japanese ")
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "menu-item px-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/france.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" French ")
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "menu-item px-5 my-1" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Account Settings ")
const _hoisted_45 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.user.full_name.substring(0, 20)) + " ", 1),
            _hoisted_7
          ]),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.user.email.substring(0, 20)), 1)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        to: "/profile",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.currentLangugeLocale.name) + " ", 1),
              _createElementVNode("img", {
                class: "w-15px h-15px rounded-1 ms-2",
                src: _ctx.currentLangugeLocale.flag,
                alt: "metronic"
              }, null, 8, _hoisted_17)
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('id'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('id') }])
          }, _hoisted_22, 2)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('en'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }])
          }, _hoisted_26, 2)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLang('es'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('es') }])
          }, _hoisted_30, 2)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLang('de'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('de') }])
          }, _hoisted_34, 2)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLang('ja'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('ja') }])
          }, _hoisted_38, 2)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("a", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setLang('fr'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('fr') }])
          }, _hoisted_42, 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_44
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("a", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}